module.exports = __webpack_public_path__ + "img/globalIcon4.9e9bcd53.png";